import { ENDPOINTS, TASK_TYPES } from 'features/daily-plan/constants';
import { DataSheetPreview } from 'features/data-sheet';
import { SECONDARY_API_CLIENT } from 'services/API';
import { Permissions, userHasPermission } from 'services/Authorization';
import strings from 'strings';
import { ProfileTablesPreferenceKeys } from 'UI/components/organisms/inventoryProfiles/tabKeys';
import {
  formatTasksResponse,
  TASK_COLUMNS,
  TASKS_EXTRA_RENDERERS,
  TasksTab
} from 'UI/components/organisms/inventoryProfiles/TasksTab';
import { Endpoints } from 'UI/constants/endpoints';
import { ContactRole, ENTITY_TYPE_ID_MAP, EntityType, TabKeys } from 'UI/constants/entityTypes';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { hasFeatureFlag } from 'UI/utils';

import { formatDatasheetResponse } from './ContactProfile.utils';

export const ALLOWED_TASKS_BY_CONTACT_ROLE = {
  [ContactRole.Candidate]: [TASK_TYPES.other, TASK_TYPES.recruitJobOrder],
  [ContactRole.HiringAuthority]: [TASK_TYPES.other, TASK_TYPES.marketCandidate],
  [ContactRole.Name]: [TASK_TYPES.other]
};

export const getContactTabsDefinition = roleId => [
  {
    id: TabKeys.Tasks,
    label: strings.inventoryProfiles.sections.tabs.actionPlan.tabLabel,
    Component: TasksTab,
    visible: () =>
      userHasPermission(Permissions.DailyPlan.CanUseModule) &&
      hasFeatureFlag(FeatureFlags.DailyPlanAddTaskFromProfile),
    props: {
      allowedTaskTypes: ALLOWED_TASKS_BY_CONTACT_ROLE[roleId] ?? [TASK_TYPES.other],
      DataTableProps: {
        apiVersion: 1,
        endpoint: ENDPOINTS.tasks,
        formatResponse: formatTasksResponse
      },
      entityType: EntityType.Contact,
      entityTypeId: ENTITY_TYPE_ID_MAP.contact,
      extraRenderers: TASKS_EXTRA_RENDERERS,
      initialColumns: TASK_COLUMNS,
      tablePreferencesKey: ProfileTablesPreferenceKeys.ContactsTasks
    }
  },
  {
    id: TabKeys.DataSheet,
    label: strings.inventoryProfiles.sections.tabs.dataSheet.tabLabel,
    visible: () => hasFeatureFlag(FeatureFlags.ContactsDataSheetTab),
    Component: DataSheetPreview,
    props: {
      apiInstance: SECONDARY_API_CLIENT,
      endpoint: Endpoints.ContactDataSheetById,
      entityType: EntityType.Contact,
      formatResponse: formatDatasheetResponse
    }
  }
];
